<template>
  <survey-management
    title="label_sideMenu_violenceSurvey_surveyManagement"
    template-id="ViolenceSurvey"
    background-color="#f5fafd"
  />
</template>
<script >
import SurveyManagement from "./SurveyManagement";
import { mapGetters } from "vuex";
export default {
  name: "WorkspaceSurveyManagement",
  components: { SurveyManagement },
  computed: {
    ...mapGetters(["getCurrentSnapshot"]),
  },
  watch: {
    getCurrentSnapshot: {
      deep: true,
      handler() {
        this.checkAccess();
      },
    },
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      if (!this.getCurrentSnapshot.surveyViolenceStatus) {
        this.$router.push("/home");
      }
    },
  },
};
</script >
<style lang="sass" >
.modal
  text-align: center
  .modal-title
    width: 100%
</style >
